import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="tw-min-h-screen tw-bg-gray-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-px-4">
      <div className="tw-text-center">
        <h1 className="tw-text-9xl tw-font-bold tw-text-gray-200">404</h1>
        <h2 className="tw-mt-4 tw-text-2xl tw-font-semibold tw-text-gray-900">
          Page non trouvée
        </h2>
        <p className="tw-mt-2 tw-text-gray-600">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <div className="tw-mt-6">
          <Link
            to="/dashboard"
            className="tw-inline-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-bg-blue-600 tw-rounded-md hover:tw-bg-blue-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-blue-500"
          >
            <svg className="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
            </svg>
            Retour au dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
